import { useTranslation } from "react-i18next"
import { Button, Card, Icon } from "semantic-ui-react"
import { FileChooserDropzoneTrigger } from "simplydo/react/components/Choosers/FileChooser/FileChooserDropzoneTrigger"
import { allowedImageTypesList } from "simplydo/react/components/Choosers/FileChooser/uploadUtils"
import styled from "styled-components"

import { ImageChooser } from "components/lib/Choosers"

import { BodySegment } from "./styles"

const StyledImage = styled.img`
  max-width: 100%;
  display: block;
  object-fit: contain;
`

type ImageComponentProps = {
  image: string
  onRemove?: () => void
}

const ImageComponent = ({ image, onRemove }: ImageComponentProps) => {
  const { t } = useTranslation()

  return (
    <Card.Group centered>
      <Card style={{ width: "80%" }}>
        <Card.Content style={{ color: "#808080" }}>
          <Icon name="images" />
          Uploaded image
        </Card.Content>
        <Card.Content textAlign="center">
          <Card.Header style={{ overflowWrap: "break-word" }}>
            <StyledImage alt={`${t("common:capitalise", { key: "generic.idea" })} field content`} src={image} />
          </Card.Header>
        </Card.Content>
        <Card.Content extra>
          <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 10 }}>
            <Button
              as="a"
              href={image}
              target="_blank"
              rel="noopener noreferrer"
              download={image}
              fluid
              basic
              icon="download"
              content={t("generic.download")}
              style={{ marginLeft: 0, marginRight: 0 }}
              size="small"
            />
            {onRemove ? (
              <Button basic size="small" icon="trash" onClick={onRemove} style={{ marginLeft: 0, marginRight: 0 }} />
            ) : null}
          </div>
        </Card.Content>
      </Card>
    </Card.Group>
  )
}

type ImageProps = {
  field: any
  ideaId: any
  fieldValue: any
  updateIdea: any
  isEditing: boolean
}

const Image = ({ field, ideaId, fieldValue = "", updateIdea, isEditing }: ImageProps) => {
  if (!isEditing) {
    if (fieldValue) {
      return <ImageComponent image={fieldValue} />
    }
    return null
  }

  if (fieldValue) {
    return (
      <BodySegment>
        <ImageComponent image={fieldValue} onRemove={() => updateIdea(null, ["templated", field.id])} />
      </BodySegment>
    )
  }

  return (
    <ImageChooser
      trigger={
        <FileChooserDropzoneTrigger
          forType="idea"
          accept={allowedImageTypesList.join(",")}
          forId={ideaId}
          onComplete={(_value, _name, imageSrc) => updateIdea(imageSrc, ["templated", field.id])}
          dropzoneProps={{ title: "Upload an image", DropZoneComponent: BodySegment, defaultIcon: "image" }}
        />
      }
      forType="idea"
      forId={ideaId}
      onComplete={(_value, _name, imageSrc) => updateIdea(imageSrc, ["templated", field.id])}
    />
  )
}

export default Image
